<main class="auth-container">
    <router-outlet></router-outlet>
  </main>
  